<template>
  <div class="table-query-wrapper">
    <a-form class="query-form" :model="model">
      <slot />
    </a-form>
    <div class="table-query-buttons">
      <a-space>
        <slot name="query-button">
          <template>
            <a-button @click="reset">重置</a-button>
            <a-button type="primary" @click="$emit('query')">查询</a-button>
          </template>
        </slot>
      </a-space>
      <slot name="show-more"></slot>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
export default {
  name: "LinTableQuery",
  props: {
    model: Object,
  },
  data() {
    return {
      modelInterface: {}
    }
  },
  created() {
    Object.keys(this.model).forEach(key => {
      const value = _.cloneDeep(this.model[key])
      this.$set(this.modelInterface, key, value)
    })
  },
  methods: {
    reset() {
      Object.keys(this.model).forEach(key => {
        this.model[key] =  _.cloneDeep(this.modelInterface[key])
      })
      this.$emit('reset')
    }
  }
}
</script>

<style lang="scss" scoped>
.table-query-wrapper {
  display: flex;

  .table-query-buttons {
    line-height: 40px;
  }

  .query-form {
    flex: 1;
    margin-right: 15px;
    /deep/ .ant-calendar-picker {
      width: 100%;
    }
  }

  /deep/ .ant-form-item {
    display: flex;
  }

  /deep/ .ant-form-item-control-wrapper {
    flex: 1;
  }
}
</style>
